module.exports = __webpack_public_path__ + "img/goods_dis.07316d02.png";